const Shippers = [{
  path: '/ecommerce/supply',
  name: 'shippers',
  component: () => import(/* webpackChunkName: "shippers-base" */ './ShippersView.vue'),
  meta: {
    requiresAuth: true,
    breadCrumbs: [{
      name: 'Shippers',
      path: '/ecommerce/inventory/shippers',
    }],
  },
  children: [
    {
      path: 'shippers',
      name: 'shippers',
      component: () => import(/* webpackChunkName: "all-shippers" */ './components/Shippers.vue'),
      meta: {
        requiresAuth: true,
        breadCrumbs: [{
          name: 'All Shippers',
          path: '/inventory/shippers',
        }],
      },
    },
  ],
}];

export default Shippers;
